/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: IntHash
 * root Object
 * @constructor
 */
window.IntHash = function() {
	this.h = { };
};
$hxClasses['IntHash'] = IntHash;
/** @private @type {Array} */
IntHash.__name__ = ["IntHash"];

/**
 * toString
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this IntHash
 * @return {string}
 */
IntHash.prototype.toString = function() {
	/** @type {StringBuf} */ 
	var s = new StringBuf();
	s.b += Std.string("{");
	/** @type {Iterator} */ 
	var it = this.keys();
	while( it.hasNext() ) {
		var i = it.next();
		s.b += Std.string(i);
		s.b += Std.string(" => ");
		s.b += Std.string(Std.string(this.get(i)));
		if(it.hasNext()) s.b += Std.string(", ");
	}
	s.b += Std.string("}");
	return s.b;
};


/**
 * iterator
 *
 * $type TFun([],TType(Iterator,[TInst(IntHash.T,[])]))
 * @public
 * @this IntHash
 * @return {Iterator}
 */
IntHash.prototype.iterator = function() {
	return { ref : this.h, it : this.keys(), hasNext : function() {
		return this.it.hasNext();
	}, next : function() {
		/** @type {number} */ 
		var i = this.it.next();
		return this.ref[i];
	}};
};


/**
 * keys
 *
 * $type TFun([],TType(Iterator,[TInst(Int,[])]))
 * @public
 * @this IntHash
 * @return {Iterator}
 */
IntHash.prototype.keys = function() {
	/** @type {Array} */
	var a = [];
	for( var key in this.h ) {
	if(this.h.hasOwnProperty(key)) a.push(key | 0);
	}
	return HxOverrides.iter(a);
};


/**
 * remove
 *
 * $type TFun([{ name => key, t => TInst(Int,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @this IntHash
 * @param {number}  key 
 * @return {boolean}
 */
IntHash.prototype.remove = function(key) {
	if(!this.h.hasOwnProperty(key)) return false;
	delete(this.h[key]);
	return true;
};


/**
 * exists
 *
 * $type TFun([{ name => key, t => TInst(Int,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @this IntHash
 * @param {number}  key 
 * @return {boolean}
 */
IntHash.prototype.exists = function(key) {
	return this.h.hasOwnProperty(key);
};


/**
 * get
 *
 * $type TFun([{ name => key, t => TInst(Int,[]), opt => false }],TType(Null,[TInst(IntHash.T,[])]))
 * @public
 * @this IntHash
 * @param {number}  key 
 * @return {Null}
 */
IntHash.prototype.get = function(key) {
	return this.h[key];
};


/**
 * set
 *
 * $type TFun([{ name => key, t => TInst(Int,[]), opt => false },{ name => value, t => TInst(IntHash.T,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this IntHash
 * @param {number}  key 
 * @param {IntHash.T}  value 
 * @return {void}
 */
IntHash.prototype.set = function(key,value) {
	this.h[key] = value;
};

/** @private @type {null} */
IntHash.prototype.h = null;
/** @type {IntHash} */
IntHash.prototype.__class__ = IntHash;
